import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Utilisation de useNavigate

import { login } from "../components/FuncUtils"; // Import de la fonction de connexion

export default function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(""); // Réinitialiser les erreurs

    try {
      const response = await login(email, password); // Appel de la fonction de connexion
      // Envoie la requête de connexion à l'API
      /*const response = await axios.post(
        "https://api-mf2n35o27a-uc.a.run.app/login",
        {
          email,
          password,
        }
      );*/

      // Vérifie la réponse et récupère les tokens
      const idToken = JSON.parse(response).idToken;
      const refreshToken = JSON.parse(response).refreshToken;

     
      // Mettre à jour l'état de l'utilisateur dans le parent (App.js)
      setUser({ idToken, refreshToken }); // Mettez ici les informations de l'utilisateur que tu veux stocker

      // Redirige l'utilisateur vers une page protégée après la connexion
      navigate("/users");
    } catch (err) {
      console.error("Erreur lors de la connexion:", err);
      setError("Identifiants incorrects. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "50px auto",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      <h2>Se connecter</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={handleLogin}>
        <div style={{ marginBottom: "10px" }}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: "100%", padding: "8px", marginTop: "5px" }}
          />
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label htmlFor="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: "100%", padding: "8px", marginTop: "5px" }}
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          >
            {loading ? "Chargement..." : "Se connecter"}
          </button>
        </div>
      </form>
    </div>
  );
}
